import React from 'react'
import { EmptyScreenStyles } from './Style'
import { EmptyLab } from 'assets'
import { Img } from 'styles/GlobalStyle'

const EmptyScreen = () => {

    return (
        <EmptyScreenStyles>
            <div className='empty-screen-title'>
                {"צריך לבחור איזה תוצאה רוצים לראות"}
            </div>
            <div className='empty-screen-sub-title'>
                <div>{"בוחרים במסננים למעלה ואז"}</div>
                <div>{"מוצגות התוצאות."}</div>
            </div>
            <div>
                <div className='empty-lab'>
                    <Img src={EmptyLab} />
                </div>
            </div>
        </EmptyScreenStyles>
    )
}

export default EmptyScreen